import { store } from "../../store";

export const REMOTE_URL = "";
export const GET_DEPT_URL = "/api/v1/regions/regions_with_offices";
export const ADD_DEPT_URL = "/api/v1/regions/create";
export const UPD_DEPT_URL = "/api/v1/regions/update";
export const GET_BY_POST =
  "/api/v1/regions/region_with_parent_ids_by_post_code/";
